// extracted by mini-css-extract-plugin
export default {"categoryContainer":"CategoryKeyword_categoryContainer__89lYo"};